export default "__VITE_ASSET__61c6b8b1__"